var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"errors mt-4"},[_c('h1',[_vm._v("404 Error")]),_c('p',[_vm._v("Page not found")]),_c('router-link',{attrs:{"to":"/","exact":""}},[_vm._v(" Go to home page ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }